import { render, staticRenderFns } from "./BusinessInformationOtherInfo.vue?vue&type=template&id=e948d024"
import script from "./BusinessInformationOtherInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInformationOtherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports